<template>
    <b-modal :id="id" size="30rem" hide-footer hide-header @show="setKrInForm">
        <div id="header">
            <span class="title">{{
                $t('form.create', {
                    item: $t('daily.initiative'),
                })
            }}</span>
            <i class="close-button fas fa-times" @click="closeModal" />
        </div>
        <b-row>
            <b-col class="form-column">
                <Form
                    v-if="loadForm"
                    ref="form"
                    @submit="onSubmit"
                    @cancel="closeModal"
                    :isSubmitting="isSubmitting"
                    :krId="krId"
                />
            </b-col>
        </b-row>
    </b-modal>
</template>
<script>
import api from '@/services/api'
import { Form } from './components'
import { success, danger } from '@/lib/notification'

export default {
    components: {
        Form,
    },
    props: {
        krId: {
            type: Number,
        },
        idSufix: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            id: 'new-initiative-modal' + this.idSufix,
            isSubmitting: false,
            loadForm: false,
        }
    },
    created() {
        this.$emit('openModal', this.openModal)
    },
    methods: {
        setKrInForm() {
            this.loadForm = true
            this.$nextTick(() => this.$refs.form.setKrInForm())
        },
        onSubmit(payload) {
            this.isSubmitting = true
            api.post('/initiatives', payload)
                .then(() => {
                    this.$store.dispatch('daily/getInitiativesFromAPI')
                    this.showSuccessNotification()
                    this.closeModal()
                    this.$emit('created')
                })
                .catch((e) => {
                    console.error(e)
                    this.showErrorNotification()
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        },
        showSuccessNotification() {
            success(
                this.$t('notification.createdSuccessfully', {
                    item: `Iniciativa`,
                })
            )
        },
        showErrorNotification() {
            danger()
        },
        openModal() {
            this.$bvModal.show(this.id)
        },
        closeModal() {
            this.$bvModal.hide(this.id)
            this.loadForm = false
        },
    },
}
</script>

<style lang="scss" scoped>
#header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
        font-size: 24px;
        font-weight: 700;
        text-align: left;
        color: #022b4f;
    }

    .close-button {
        color: #3b3f4e;
        cursor: pointer;
        font-size: 18px;
    }
}

::v-deep .modal-lg {
    max-width: 900px;
}

.descriptions-column {
    padding: 1rem;
}

.form-column {
    padding: 1rem;
}
</style>
